'use client';

import { createContext, useState } from 'react';
import type { PropsWithChildren } from 'react';
import { useCookie } from 'react-use';

import {
  demoSettingsCookieName,
  getDemoSettingsCookieExpiration,
  getDemoSettingsFromCookie,
  type DemoSettings,
  type Environment,
} from './environment';

export const EnvironmentContext = createContext<
  | (Environment & {
      authToken: string;
      updateAuthToken: (token: string) => void;
      demoSettings: DemoSettings;
      updateDemoSettings: (settings: DemoSettings) => void;
    })
  | null
>(null);

export const EnvironmentProvider = ({
  environment,
  authToken,
  children,
}: PropsWithChildren<{
  environment: Environment;
  authToken: string;
}>) => {
  const [token, setToken] = useState(authToken);
  const [demoSettingsCookie, updateDemoSettingsCookie] = useCookie(
    demoSettingsCookieName
  );

  const [demoSettings, setDemoSettings] = useState(
    getDemoSettingsFromCookie(demoSettingsCookie)
  );

  return (
    <EnvironmentContext.Provider
      value={{
        ...environment,
        authToken: token,
        updateAuthToken: setToken,
        demoSettings,
        updateDemoSettings: (settings) => {
          setDemoSettings(settings);
          updateDemoSettingsCookie(JSON.stringify(settings), {
            expires: getDemoSettingsCookieExpiration(),
          });
        },
      }}
    >
      {children}
    </EnvironmentContext.Provider>
  );
};
